
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-cases/technology",
      function () {
        return require("private-next-pages/use-cases/technology.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/use-cases/technology"])
      });
    }
  